const InsuranceChallenge2HintsText =
    ["Monthly premium is the amount you pay for the insurance.  Deductible is the amount " +
         "that you have to pay before the insurance kicks in.  So you may review plans " +
         "where you have pay less each month, but if you do need the insurance, you will have " +
         "to pay a lot out-of-pocket.",
     "Deciding you don't need insurance because it can't/won't happen to you is not a good plan",
     "You can be covered on your parent's health insurance plan until you are 26 years old.",
     "There are a lot of different insurance companies, it is good to understand some " +
        "of the different options and costs offered by different insurance companies."
    ]

export default InsuranceChallenge2HintsText;